import { useaxios } from "../../../utils/useaxios";
export default (text) => setname => setprice => {
    // initDispatch({ type: 'loadingTrue' });
    useaxios('item/getitem.php', { text }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            setname(res.data[0].item_name);
            setprice(res.data[0].item_price);
        } else {
            setname('');
            setprice('')
            alert('کاڵا نەدۆزرایەوە');
        }
        // setloading(false);
    });
}